import { EpicH1Span } from "@constellation-academy/epic-ui";
import { useState } from "react";
import { useLazyLoadQuery } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { offerSubscriptions_Query } from "@relay/offerSubscriptions_Query.graphql";
import { QUERY } from "./offer-subscriptions.graphql";
import { headerWrapperClass } from "./offer-subscriptions.styles";
import { OfferSubscriptionsTable } from "./parts/offer-subscriptions-table";
import { BaseScreen } from "../../components/base-screen";

export const OfferSubscriptionsScreen = () => {
	const { t } = useTranslation("common");
	const [fetchKey, setFetchKey] = useState(0);

	const query = useLazyLoadQuery<offerSubscriptions_Query>(
		QUERY,
		{ first: 50 },
		{ fetchPolicy: "network-only", fetchKey },
	);

	const subscriptions = (query.Admin.Offer.mySubscriptions.edges ?? [])
		.filter((e): e is NonNullable<typeof e> => e != null)
		.map((e) => e.node);

	return (
		<BaseScreen>
			<div className={headerWrapperClass}>
				<EpicH1Span>{t("offerSubscriptions.title")}</EpicH1Span>
			</div>
			<OfferSubscriptionsTable
				subscriptions={subscriptions}
				onRefetch={() => setFetchKey((k) => k + 1)}
			/>
		</BaseScreen>
	);
};
